import { z } from 'zod';

// Formatul comun al unei linii de log, dupa normalizarea facuta de Vector — docs/16 §7 si
// docs/17. Aceleasi campuri in VictoriaLogs, in ops.logs (Supabase) si in arhiva.

export const LOG_LEVELS = ['trace', 'debug', 'info', 'warn', 'error', 'fatal'] as const;
export const LogLevel = z.enum(LOG_LEVELS);
export type LogLevel = z.infer<typeof LogLevel>;

// Nivelurile numerice pino. Aceeasi tabela e in platform/deploy/vps/vector/vector.yaml
// (transformarea `normalize`); testele lui Vector verifica partea lui.
const PINO_LEVELS: ReadonlyArray<readonly [number, LogLevel]> = [
  [60, 'fatal'],
  [50, 'error'],
  [40, 'warn'],
  [30, 'info'],
  [20, 'debug'],
  [10, 'trace'],
];

export function levelFromPino(value: number): LogLevel {
  for (const [threshold, level] of PINO_LEVELS) {
    if (value >= threshold) return level;
  }
  return 'trace';
}

// Ce ajunge in Supabase (ops.logs): doar ce merita pastrat si cu VPS-ul oprit.
export function isPersistedLevel(level: LogLevel): boolean {
  return level === 'warn' || level === 'error' || level === 'fatal';
}

export const LogRecord = z.object({
  timestamp: z.iso.datetime({ offset: true }),
  level: LogLevel,
  service: z.string().min(1),
  message: z.string(),
  job_id: z.uuid().optional(),
  phase: z.string().optional(),
  stream: z.enum(['stdout', 'stderr', 'file']).optional(),
});
export type LogRecord = z.infer<typeof LogRecord>;
